export default __webpack_public_path__ + "static/media/457b_dark.6d015717.png";